var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-contentWrap"},[_c('div',{staticClass:"modal-header bg-1"},[_c('modal-close'),_c('div',{staticClass:"modal-title text-center mb-0 mb-md-2"},[_c('h2',{staticClass:"h3 mb-1 mt-2"},[_vm._v(" Załączniki do grupy promocji ("+_vm._s(_vm.modalArgs.groupAttachments.length)+" szt.) ")]),_c('div',[_vm._v(_vm._s(_vm.modalArgs.name))])])],1),_c('div',{staticClass:"modal-body px-2 py-4 px-sm-4"},[_c('div',{staticClass:"no-expanded-slider"},[_c('promotion-slider',{attrs:{"data":_vm.setGroupAttachmentsData,"responsive":{
                        120: {
                            items: 1.2
                        },
                        320: {
                            items: 1.2
                        },
                        520: {
                            items: 2.2
                        },
                        768: {
                            items: 2.2
                        },
                        992: {
                            items: 3.2
                        },
                        1200: {
                            items: 4.2
                        }
                    },"show-download-btn":true}})],1)]),_c('div',{staticClass:"modal-footer flex-wrap flex-sm-nowrap",staticStyle:{"position":"sticky","bottom":"0","background":"white"}},[_c('the-btn',{staticClass:"btn-outline-custom btn-block my-0 mb-sm-0 mb-2",attrs:{"text":"Powrót"},nativeOn:{"click":function($event){return _vm.$store.dispatch('toggleModal', false)}}}),_c('the-btn',{staticClass:"btn-block my-0",attrs:{"text":"Pobierz wszystkie załączniki","icon":"Download","loading-status":_vm.$store.getters.getAllGroupAttachmentsStatus},nativeOn:{"click":function($event){return _vm.downloadAllGroupAttachments.apply(null, arguments)}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }